import {IReduxFormsState} from '../../@interfaces';

const state: IReduxFormsState = {
	configsLoaded: false,
};

export default state;
